import React from 'react'
import {createRoot} from 'react-dom/client'
import ConfigProvider from 'antd/es/config-provider';
import AntApp from 'antd/es/app';

import ukUA from 'antd/locale/uk_UA'
import AppRouter from './router'
import {AuthProvider} from './auth/AuthContext'
import {UIProvider} from "@/context/UIContext";

import 'antd/dist/reset.css'
import './index.css'

createRoot(document.getElementById('root')).render(
    <UIProvider>
        <ConfigProvider locale={ukUA}>
            <AntApp>
                <AuthProvider>
                    <AppRouter/>
                </AuthProvider>
            </AntApp>
        </ConfigProvider>
    </UIProvider>
)
